import { useEffect, useState } from 'react';

/**
 * @description: if smartform element accepts "initialValue" from the user input - this hook helps you to map user input to the value accepted by the component
 * @param valueToSet - if null - mark this hook as completed/initialized
 */
export function useInitialValueMapper<T>(valueToSet: T | undefined | null, setValue: (val: T) => void) {
  const [initialized, setInitialized] = useState(false);

  useEffect(() => {
    if (!initialized && valueToSet === null) {
      setInitialized(true);
      return;
    }
    if (!initialized && !!valueToSet) {
      setValue(valueToSet);
      setInitialized(true);
    }
  }, [valueToSet, initialized, setValue]);
}
